import send from '../../utils/fetch'
import getUseServer from "@/utils/getServer"
import router from '@/router'

const server = getUseServer()

const fetch = async (data, server) => {
    return new Promise( resolve => {
        return send(global.$url.login.get, 'POST', {data, server}, false)
            .then(response => resolve({result: response.data.result, serv: server.name}))
            .catch(err => resolve({error: err, serv: server.name}))
    })
}

const state = {
    token: localStorage.getItem(server.name) || '',
    server: ''
}

const actions = {
    async isLogin({commit, dispatch}, {data, server}) {
        const response = await fetch(data, server)

        if (response.result) {
            localStorage.setItem('server', server.name)

            commit('SET_TOKEN', {
                name: response.serv,
                token: response.result.user.token.plainTextToken
            })
        } else {
            await dispatch('ADD_ERROR', {
                server: server.name,
                error: response.error.message ? 'Unknown error' : response.error.response.data.message
            })
        }

        return response
    },

    async LOGIN({commit, dispatch}, {data, ss}) {
        const setServer = name => localStorage.setItem('server', name)

        const setServerToStorage = name => commit('SET_SERVER', name)

        const api_servers = (JSON.parse(process.env.VUE_APP_API_SERVERS) || [])

        let selectServer = {}

        const errors = []

        for (const serv of api_servers) {
            const response = await fetch(data, serv)

            if (response.result) {
                selectServer = response
                break
            }

            if (response.error) {
                errors.push(response)
            }
        }

        if (api_servers.length === errors.length) {
            dispatch('AUTH_ERROR')
            await dispatch('ADD_ERROR', errors[0].error.message)
            return Promise.reject(errors[0].error)
        }

        if (Object.keys(selectServer).length) {
            setServer(selectServer.serv)
            setServerToStorage(selectServer.serv)

            commit('SET_TOKEN', {
                name: selectServer.serv,
                token: selectServer.result.user.token.plainTextToken
            })

            const user = selectServer.result.user
            if (!Boolean(user.team.is_active)) {
                dispatch('AUTH_ERROR')
                await dispatch('ADD_ERROR', `Access denied. ${user.team.name} disabled`)
                return Promise.reject(`${user.team.name} disabled`)
            }

            dispatch('setUserPermissions', user.permissions)
            dispatch('setSystemSettings', user.system_settings)
            dispatch('setUserInfo', user)
            dispatch('AUTH_SUCCESS')
        }

        return selectServer
    },

    async authAutologinLinkedUser({commit, dispatch}, {hash}) {
        try {
            const response = await send(global.$url.login['auth-autologin-linked-user'], 'GET', {params: {hash}})
                .then(response => response.data.result)

            const serverName = localStorage.getItem('server')

            commit('SET_TOKEN', {
                name: serverName,
                token: response.user.token.plainTextToken
            })

            dispatch('setUserPermissions', response.user.permissions)
            dispatch('setSystemSettings', response.user.system_settings)
            dispatch('setUserInfo', response.user)
            dispatch('AUTH_SUCCESS')

            const hasAccess = response.user.permissions.some(item => item.model.slug === router.currentRoute.meta.permissionName && item.permission.slug === 'access');
            if (!hasAccess && router.currentRoute.name !== 'home') {
                await router.push({ name: 'home' })
            } else {
                location.reload()
            }
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async autologin({commit, dispatch, getters}, hash) {
        try {
            const response = await send(global.$url.user.autologin, 'GET', {params: {hash}})
                .then(response => response.data.result)

            dispatch('setUserInfo', response.user)
            dispatch('setUserPermissions', response.user.permissions)
            dispatch('setSystemSettings', response.user.system_settings)

            if (!getters.aUser.name) {
                localStorage.setItem(`start_${server.name}`, localStorage.getItem(server.name))

                const startUser = await send(global.$url.user.get_user, 'GET', {options: {token: localStorage.getItem(`start_${server.name}`)}})
                    .then(response => response.data.result)
                commit('SET_AUTOLOGIN_USER', startUser)
            }

            localStorage.removeItem(server.name)
            commit('SET_TOKEN', response.user.token.plainTextToken)
            await router.push('/home')
            return response.user
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async autologinGoStartUser({commit, dispatch, getters, state}) {
        localStorage.setItem(server.name, localStorage.getItem(`start_${server.name}`))
        localStorage.removeItem(`start_${server.name}`)

        dispatch('AUTH_SUCCESS')
        commit('CLEAR_AUTHUSER')
        await dispatch('GET_USER_DATA')

        if (location.pathname !== '/home') {
            await router.push('/home')
        }
    },

    async GET_USER_DATA({dispatch}, token) {
        try {
            const options = {}
            if (token) options.token = token

            const {data} = await send(global.$url.user.get_user, 'GET', options)

            if (!Boolean(data.result.team.is_active)) {
                dispatch('AUTH_ERROR')
                await dispatch('ADD_ERROR', `Access denied. ${data.result.team.name} disabled`)
                return Promise.reject(`${data.result.team.name} disabled`)
            }

            if (!token) {
                dispatch('setUserPermissions', data.result.permissions)
                dispatch('setUserInfo', data.result)
            }
            dispatch('setSystemSettings', data.result.system_settings)

            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async LOGOUT({commit, dispatch}) {
        try {
            //Add server send
            dispatch('AUTH_ERROR')
        } catch (e) {
        }
    },

    SET_TOKEN({commit, dispatch}, token) {
        commit('SET_TOKEN', token)
        dispatch('AUTH_SUCCESS')
    },

    CLEAR_TOKEN({commit}) {
        commit('CLEAR_TOKEN')
    }
}

const mutations = {
    SET_SERVER(state, payload) {
        state.server = payload
    },

    SET_TOKEN(state, token) {
        let name = server.name
        if (token.name) {
            name = token.name
        }

        const bearerToken = `Bearer ${token.token || token}`
        localStorage.setItem(name, bearerToken)

        state.token = bearerToken
    },

    CLEAR_TOKEN(state) {
        const serverNames = (JSON.parse(process.env.VUE_APP_API_SERVERS) || [])
            .map(item => item.name)

        serverNames.map(name => {
            localStorage.removeItem(name)
            localStorage.removeItem(`start_${name}`)
        })

        state.token = ''
    }
}

const getters = {
    token: state => state.token,
    server: state => state.server
}

export default {
    state,
    actions,
    mutations,
    getters
}
